<div class="wrapper" *ngIf="!(breakpointService.breakpoint$ | async | breakpointIs : 'mobile')" #wrapper>
    <app-image *ngIf="image" [image]="image" [width]="image.width || 1440" [height]="image.height || 800" crop="crop"></app-image>
    <ng-container *ngFor="let point of touchPoints">
        <div
            class="touch-point"
            *ngIf="point.details as details"
            (mouseenter)="checkPosition(description, wrapper)"
            [ngStyle]="{
                'top.%': point.yPosition,
                'left.%': point.xPosition
            }"
        >
            <a class="link" [routerLink]="details.productUrl">
                <span class="kk-visuallyhidden">{{ details.productName }}</span>
            </a>
            <div class="description" aria-hidden="true" #description>
                <div class="image" *ngIf="details.imageUrl">
                    <app-image
                        [image]="{ src: details.imageUrl, name: details.productName }"
                        [height]="94"
                        [width]="94"
                    ></app-image>
                </div>
                <div class="info">
                    <div class="description-brand" *ngIf="details.brand as brand">
                        {{ brand.text }}
                    </div>
                    <div class="description-name">
                        {{ details.productName }}
                    </div>
                    <div class="description-price">
                        <app-product-price
                            [line]="details"
                            type="lite"
                            [settings]="{ showPoints: false, forceEqualHeight: false }"
                        ></app-product-price>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<div class="wrapper" *ngIf="breakpointService.breakpoint$ | async | breakpointIs : 'mobile'" #wrapper>
    <app-image *ngIf="image" [image]="image" [width]="image.width || 720" [height]="image.height || 400" crop="crop"></app-image>
    <ng-container *ngFor="let point of touchPoints">
        <div
            class="touch-point"
            [ngStyle]="{
                'top.%': point.yPosition,
                'left.%': point.xPosition
            }"
            *ngIf="point.details as details"
        >
            <a class="link" [routerLink]="details.productUrl">
                <span class="kk-visuallyhidden">{{ details.productName }}</span>
            </a>
        </div>
    </ng-container>
</div>
